




















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import DisabledInput from '@/components/shared/DisabledInput.vue';

@Component({
  components: {
    DisabledInput,
  }
})
export default class Collapse extends Vue {
  private isOpen: boolean = false 
  @Prop({default: false}) private open!: boolean;
  @Prop({default: 'title'}) private title!: string;
  @Prop() private content: any;

  public async mounted() {
    this.isOpen = this.open;
  }
}
